// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__XJI4Y","modal":"Modal_modal__Qz4VZ","slide-down":"Modal_slide-down__9wVeM"};